import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import moment from 'moment';
import { KnBrDateFormatService } from './kn-br-date-format.service';

@Injectable({
  providedIn: 'root',
})
export class MomentDateFormatter extends NgbDateParserFormatter {
  constructor(private dateFormatService: KnBrDateFormatService) {
    super();
  }

  parse(value: string): NgbDateStruct {
    if (!value) {
      return null;
    }
    // Also accept ISO/YYYYMMDD here (see KnBrDateHelper.getDate) -- browser autofill or a
    // native input/change event firing before the field is fully patched can hand this
    // parser text that isn't yet in the active display format.
    const mdt = moment(value.trim(), [moment.ISO_8601, 'YYYYMMDD', this.dateFormatService.getDateFormat()], true);
    return mdt.isValid() ? { day: mdt.date(), month: mdt.month() + 1, year: mdt.year() } : null;
  }

  format(date: NgbDateStruct): string {
    if (!date) {
      return '';
    }
    const mdt = moment([date.year, date.month - 1, date.day]);
    return mdt.isValid() ? mdt.format(this.dateFormatService.getDateFormat()) : '';
  }
}
